import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="py-20">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold mb-8 text-center text-blue-300">Contact Me</h2>
        <div className="max-w-md mx-auto bg-white bg-opacity-10 rounded-lg shadow-lg p-8">
          <p className="mb-6 text-center text-gray-300">
            Feel free to reach out to me for any opportunities or collaborations!
          </p>
          <div className="flex justify-center space-x-4">
            <a href="mailto:supriths4804@gmail.com" className="bg-red-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-600 transition duration-300 transform hover:scale-105">
              Email
            </a>
            <a href="https://linkedin.com/in/suprith-s44" target="_blank" rel="noopener noreferrer" className="bg-blue-700 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-800 transition duration-300 transform hover:scale-105">
              LinkedIn
            </a>
          </div>
          <p className="mt-6 text-center text-gray-400">
            Phone: (+91) 95383 92584
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;